import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { NgxBootstrapProductTourDirective, NgxBootstrapPopoverDirective } from './ngx-bootstrap-product-tour.directive';
import { NgxBootstrapProductTourStepComponent } from './ngx-bootstrap-product-tour-step/ngx-bootstrap-product-tour-step.component';
import { NgxBootstrapProductTourService } from './ngx-bootstrap-product-tour.service';
import { NgxBootstrapProductTourStepService } from './ngx-bootstrap-product-tour-step/ngx-bootstrap-product-tour-step.service';
export class NgxBootstrapProductTourModule {
/**
 * @return {?}
 */
public static forRoot(): ModuleWithProviders {
    return {
      ngModule: NgxBootstrapProductTourModule,
      providers: [
        NgxBootstrapProductTourService,
        NgxBootstrapProductTourStepService
      ],
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    PopoverModule.forRoot(),
  ],
  declarations: [
    NgxBootstrapProductTourDirective,
    NgxBootstrapPopoverDirective,
    NgxBootstrapProductTourStepComponent
  ],
  entryComponents: [
    NgxBootstrapProductTourStepComponent
  ],
  exports: [
    NgxBootstrapProductTourDirective,
    NgxBootstrapPopoverDirective,
    NgxBootstrapProductTourStepComponent
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NgxBootstrapProductTourModule_tsickle_Closure_declarations() {
/** @type {?} */
NgxBootstrapProductTourModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgxBootstrapProductTourModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
